var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._l(_vm.paginatedVisits, function(item) {
        return _c(
          "div",
          { key: item.visitId, staticClass: "mb-2 px-3 border-bottom" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col pl-0" }, [
                _c("span", { staticClass: "data-label" }, [_vm._v("Fecha:")]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.visitDate))
                ])
              ]),
              _c("div", { staticClass: "col-3" }, [
                _c("span", { staticClass: "data-label" }, [_vm._v("Horario:")]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.durationRange))
                ])
              ]),
              _c("div", { staticClass: "col-3" }, [
                _c("span", { staticClass: "data-label" }, [
                  _vm._v("Tipo de Visita:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.visitTypeName))
                ])
              ]),
              _c("div", { staticClass: "col" }, [
                _c("span", { staticClass: "data-label" }, [
                  _vm._v("Especialista:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.specialistName))
                ])
              ]),
              _c("div", { staticClass: "col" }, [
                _c("span", { staticClass: "data-label" }, [
                  _vm._v("Transportación:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(
                    " " + _vm._s(item.hasTransportation ? "Sí" : "No") + " "
                  )
                ])
              ])
            ])
          ]
        )
      }),
      _vm.pageCount > 1
        ? _c("pagination", {
            attrs: { data: _vm.paginationData },
            on: {
              "pagination-go-page": function($event) {
                _vm.currentPage = $event
              }
            }
          })
        : _vm._e(),
      !_vm.hasVisits ? _c("custom-result-not-found") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-3" }, [
      _c("em", { staticClass: "font-18 color-orange fa fa-info-circle mr-2" }),
      _c("span", { staticClass: "color-black font-16 font-weight-bold" }, [
        _vm._v(" Detalle de Visitas ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }